export default __webpack_public_path__ + "static/50-sitzer-2-553dd6a79e40fb240c5a0d767d7763ed.jpg";